/** CRM / Lead vocabularies (mirror backend enums in models/crm.py). */

export const RELATIONSHIP_TYPES = [
  { value: "lead", label: "Lead" },
  { value: "prospect", label: "Prospect" },
  { value: "buyer", label: "Buyer" },
  { value: "seller", label: "Seller" },
  { value: "past_client", label: "Past Client" },
  { value: "referral_partner", label: "Referral Partner" },
  { value: "vendor", label: "Vendor" },
  { value: "sphere", label: "Sphere" },
  { value: "other", label: "Other" },
];

export const LEAD_TYPES = [
  { value: "buyer", label: "Buyer" },
  { value: "seller", label: "Seller" },
  { value: "investor", label: "Investor" },
  { value: "rental", label: "Rental" },
  { value: "referral", label: "Referral" },
  { value: "other", label: "Other" },
];

export const PRIORITIES = [
  { value: "low", label: "Low" },
  { value: "normal", label: "Normal" },
  { value: "high", label: "High" },
];

export const TEMPERATURES = [
  { value: "cold", label: "Cold" },
  { value: "warm", label: "Warm" },
  { value: "hot", label: "Hot" },
];

export const PREAPPROVAL_STATUSES = [
  { value: "unknown", label: "Unknown" },
  { value: "not_started", label: "Not Started" },
  { value: "in_progress", label: "In Progress" },
  { value: "pre_qualified", label: "Pre-Qualified" },
  { value: "pre_approved", label: "Pre-Approved" },
  { value: "cash_buyer", label: "Cash Buyer" },
];

export const CONTACT_TABS = [
  { key: "all", label: "All" },
  { key: "leads", label: "Leads" },
  { key: "clients", label: "Clients" },
  { key: "past_clients", label: "Past Clients" },
  { key: "sphere", label: "Sphere" },
  { key: "referral_partners", label: "Referral Partners" },
  { key: "vendors", label: "Vendors" },
];

export const CONTACT_SORTS = [
  { value: "name", label: "Name (A–Z)" },
  { value: "recent", label: "Recently updated" },
  { value: "followup", label: "Next follow-up" },
  { value: "created", label: "Newest" },
];

export const relationshipLabel = (v) =>
  RELATIONSHIP_TYPES.find((r) => r.value === v)?.label || v || "—";
export const leadTypeLabel = (v) => LEAD_TYPES.find((r) => r.value === v)?.label || v || "—";
export const priorityLabel = (v) => PRIORITIES.find((r) => r.value === v)?.label || v || "—";
export const temperatureLabel = (v) => TEMPERATURES.find((r) => r.value === v)?.label || v || "—";

export const FOLLOWUP_TYPES = [
  { value: "call", label: "Call" },
  { value: "email", label: "Email" },
  { value: "text", label: "Text" },
  { value: "meeting", label: "Meeting" },
  { value: "check_in", label: "Check-in" },
  { value: "other", label: "Other" },
];

export const FOLLOWUP_VIEWS = [
  { key: "overdue", label: "Overdue" },
  { key: "due_today", label: "Due Today" },
  { key: "upcoming", label: "Upcoming" },
  { key: "completed", label: "Completed" },
];

export const followupTypeLabel = (v) => FOLLOWUP_TYPES.find((t) => t.value === v)?.label || v || "—";

export const TRANSACTION_TYPES = [
  { value: "purchase", label: "Purchase" },
  { value: "listing", label: "Listing" },
  { value: "lease", label: "Lease" },
  { value: "referral", label: "Referral" },
  { value: "other", label: "Other" },
];

export const REPRESENTATION_SIDES = [
  { value: "buyer", label: "Buyer" },
  { value: "seller", label: "Seller" },
  { value: "dual", label: "Dual" },
  { value: "referral", label: "Referral" },
  { value: "other", label: "Other" },
];

export const TRANSACTION_STATUSES = [
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "under_contract", label: "Under Contract" },
  { value: "pending", label: "Pending" },
  { value: "closed", label: "Closed" },
  { value: "cancelled", label: "Cancelled" },
];

export const TRANSACTION_VIEWS = [
  { key: "active", label: "Active" },
  { key: "under_contract", label: "Under Contract / Pending" },
  { key: "closed", label: "Closed" },
  { key: "cancelled", label: "Cancelled" },
  { key: "all", label: "All" },
];

export const COMMISSION_VIEWS = [
  { key: "estimated", label: "Estimated" },
  { key: "pending", label: "Pending" },
  { key: "paid", label: "Paid" },
  { key: "all", label: "All" },
];

export const txTypeLabel = (v) => TRANSACTION_TYPES.find((t) => t.value === v)?.label || v || "—";
export const sideLabel = (v) => REPRESENTATION_SIDES.find((t) => t.value === v)?.label || v || "—";
export const txStatusLabel = (v) => TRANSACTION_STATUSES.find((t) => t.value === v)?.label || v || "—";
